import BasicModel from '../basic/BasicModel'
export default {
  findSettlementRecord(vm, params, listener) {
    let action = 'settlement/findSettlementRecord.action'
    BasicModel.post(vm, action, params, listener)
  },

  findSettlementDetail(vm, params, listener) {
    let action = 'settlement/findSettlementDetail.action'
    BasicModel.get(vm, action, params, listener)
  },

  updateSettlement(vm, params, listener) {
    let action = 'settlement/updateSettlement.action'
    BasicModel.post(vm, action, params, listener)
  },
  findBussinessRecharge(vm, params, listener) {
      let action = 'business/findBussinessRecharge.action'
      BasicModel.get(vm, action, params, listener)
  },
  loadChannelDetail(vm, params, listener) {
      let action = 'channel/selectChannelByID.action'
      BasicModel.get(vm, action, params, listener)
  },

  doSettlement(vm, params, listener) {
      let action = 'settlement/settlementClue.action'
      BasicModel.post(vm, action, params, listener)
  },
  sendMsg(vm, params, listener) {
      let action = 'vote/sendVoteMsg.action'
      BasicModel.post(vm, action, params, listener)
  }


}
